gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

(function () {
    // Smooth Scroll
    let isTouchDevice = window.matchMedia('(pointer: coarse)').matches;

    if (!isTouchDevice) {
        ScrollTrigger.normalizeScroll(true);
        let smoother = ScrollSmoother.create({
            smooth: 1,
            effects: true,
            smoothTouch: false,
            wrapper: '#smooth-wrapper',
            content: '#smooth-content'
        });

        window.addEventListener('pauseSmoothScroll', () => {
            pauseSmoothScroll(true);
        });
        window.addEventListener('resumeSmoothScroll', () => {
            pauseSmoothScroll(false);
        });

        // Detect if a link's href goes to the current page
        function getSamePageAnchor(link) {
            if (
                link.protocol !== window.location.protocol ||
                link.host !== window.location.host ||
                link.pathname !== window.location.pathname ||
                link.search !== window.location.search
            ) {
                return false;
            }

            return link.hash;
        }

        // Scroll to a given hash, preventing the event given if there is one
        function scrollToHash(hash, e) {
            const elem = hash ? document.querySelector(hash) : false;
            if (elem) {
                if (e) e.preventDefault();
                smoother.scrollTo(hash, true, 'top 150px');
            }
        }

        // If a link's href is within the current page, scroll to it instead
        document.querySelectorAll('a.anchor-link[href]').forEach((a) => {
            a.addEventListener('click', (e) => {
                scrollToHash(getSamePageAnchor(a), e);
            });
        });

        // Scroll to the element in the URL's hash on load
        scrollToHash(window.location.hash);
    }

    const pauseSmoothScroll = (bool) => {
        let smootherInst = ScrollSmoother.get();

        if (bool) {
            ScrollTrigger.disable();
        } else {
            ScrollTrigger.enable();
        }

        smootherInst.paused(bool);
    };

    // Geolocation Modal
    let geolocationModalElem = document.getElementById('GeolocationModal');
    let geolocationModal;
    if (geolocationModalElem) {
        geolocationModal = new bootstrap.Modal(geolocationModalElem, { backdrop: true });
        if (geolocationModalElem.dataset.show) geolocationModal.show();
    }

    // Accessibility Focus
    let userIsTabbing = false;
    document.addEventListener(
        'keydown',
        (e) => {
            let name = e.key;
            let code = e.code;
            // Alert the key name and key code on keydown
            if (code === 'Tab') {
                document.body.classList.add('user-is-tabbing');
                userIsTabbing = true;
            }
        },
        false
    );

    document.addEventListener(
        'click',
        (e) => {
            if (userIsTabbing) {
                document.body.classList.remove('user-is-tabbing');
                userIsTabbing = false;
            }
        },
        false
    );
})();
